import styled from 'styled-components';

import { Button } from '@savgroup-front-common/core';

export const $BulkActionContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 30px;
  right: 30px;
  padding: 5px 16px;
  background-color: ${({ theme }) => theme.newUI?.defaultColors?.menu ?? theme.colors?.primary ?? '#5369eb'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.bigRadius ?? theme.borders?.radius ?? '8px'};
  display: flex;
  align-items: center;
  box-shadow: ${({ theme }) =>
    (theme.newUI?.shadows as { level1?: string; level2?: string } | undefined)?.level2 ??
    '0 4px 12px rgba(0,0,0,0.15)'};
  z-index: 50;
  box-sizing: border-box;

  @media (max-width: 768px) {
    left: 12px;
    right: 12px;
    bottom: 12px;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
  }
`;

export const $BulkActionCounter = styled.div`
  color: ${({ theme }) => theme.colors?.white ?? '#fff'};
  display: flex;
  gap: 12px;
  align-items: center;
  min-width: 0;

  @media (max-width: 768px) {
    flex: 1 1 100%;
    font-size: 0.875rem;
    flex-wrap: wrap;
    gap: 6px;
  }
`;

export const $BulkActionButton = styled(Button)`
  margin-left: auto;
  margin-right: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
`;
